// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switch-icon[data-v-2e7f9989]{height:auto;transition:.3s;transform:rotate(180deg)}.switch-icon-active[data-v-2e7f9989]{transform:rotate(0deg)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
